export const locale = {
    lang: 'en',
    data: {
        error: {
            validation: 'Validation error',
            userexists: 'Employee already exists',
            shippinglinemissing: 'No shipping line is set on this order',
            bookingtypemissing: 'No booking type is set on the selected shipping line',
            dfdsnotsupported: 'DFDS ship booking is not yet supported',
            linkedToLeg: 'This event cannot be deleted as it is linked to a leg. Please un-resource and try again.',
            legnotcommunicated: 'Communicate the leg first, then record the call-in for this stop.',
            null: ''
        },
        // Phone-only copy used by the shared mobile kit (src/styles/_mobile-kit.scss, app/common/mobile).
        mobileKit: {
            actions: 'Actions',
            more: 'More',
            cancel: 'Cancel',
            clear: 'Clear',
            apply: 'Apply',
            filters: 'Filters',
            selected: '{{count}} selected',
            selectAllOnPage: 'Select all on this page',
            dateFrom: 'From',
            dateTo: 'To',
            // Tabs of a two-list picker (MobileDualListDirective) when the lists have no titles of their own.
            available: 'Available',
            chosen: 'Selected',
            // Phone "Sort by" in a list's filters (DiMobileSortComponent).
            sort: 'Sort',
            sortBy: 'Sort by',
            defaultOrder: 'Default order',
            ascending: 'Ascending',
            descending: 'Descending',
            done: 'Done',
            id: 'ID'
        },
        // Phone-only copy shared by the card lists (F15 / R7). Screen-specific strings stay per screen.
        mobileList: {
            bulkActions: 'Bulk actions',
            processingBulk: 'Processing bulk operation...',
            noInvoicesTitle: 'No invoices',
            noInvoicesText: 'Nothing matches the current filters.',
            noOrdersTitle: 'No orders',
            noOrdersText: 'Nothing matches the current filters.',
            noBatchesTitle: 'No batches',
            noBatchesText: 'Nothing matches the current filters.',
            noRunsTitle: 'No runs',
            noRunsText: 'Nothing matches the current filters.',
            hasExtras: 'Extras',
            showOrders: 'Show orders',
            removeFromBatch: 'Remove from batch',
            hasProblems: 'Has invoicing problems',
            onHold: 'On hold',
            unacceptedExtras: 'Unaccepted extras',
            noPod: 'No POD',
            viewOrder: 'View order',
            openRun: 'Open run',
            download: 'Download'
        },
        common: {
            search: 'Search',
            view: 'View',
            confirmation: 'Confirmation',
            yes: 'Yes',
            no: 'No',
            error: 'Error',
            backgroundError: 'Sync failed',
            networkError: 'Network Error',
            sorry: 'Sorry',
            ok: 'OK',
            success: 'Success',
            cancel: 'Cancel',
            save: 'Save',
            createRun: 'Create Run',
            assigned: 'Assigned',
            unassigned: 'Unassigned',
            assign: 'Assign',
            unassign: 'Unassign',
            errorMessage: 'Requested operation failed. Please contact the administrator.',
            backgroundErrorMessage: 'Please try again or reload the page.',
            networkErrorMessage: 'Please check your internet connection.',
            tooManyRequests: 'Too many requests',
            tooManyRequestsMessage:
                'The system is receiving too many requests from your connection. Please wait {{ seconds }} seconds and try again.',
            duplicateEntity: `Duplicate entity "{{ discriminator }}" already exists.`,
            deleteFailedMessage: 'This entity cannot be deleted as it is referenced by other entities.',
            confirmText: 'Confirm',
            confirmDelete: {
                message: 'Are you sure you want to delete {{ discriminator }}?'
            },
            confirmRemoveOrderFromBatch: {
                message: 'Remove order {{orderNo}} from this batch?'
            },
            confirmDeleteUniversal: {
                message: 'Are you sure you want to delete?'
            },
            sentPdfEmails: 'PDF Emails have been sent to recipients.',
            listActions: 'Actions',
            noSelectedColumn: 'Please select at least one column to be displayed.',
            noSelectedOrder: 'Please, select at least one order before creating a Run',
            haulierOrderDatesError: 'Delivery window is set before Collection Window',
            forms: {
                validationMessages: {
                    required: {
                        default: '{{_fieldName}} is required'
                    },
                    requireAtLeastOne: {
                        default: 'At least one {{_fieldName}} must be selected'
                    },
                    floatRange: {
                        default: '{{_fieldName}} should be between {{min}} and {{max}}'
                    },
                    maxlength: {
                        default: '{{_fieldName}} can have a maximum of {{requiredLength}} characters'
                    },
                    minlength: {
                        default: '{{_fieldName}} should have a minimum of {{requiredLength}} characters'
                    },
                    min: {
                        default: '{{_fieldName}} should be more than or equal to {{min}}'
                    },
                    max: {
                        default: '{{_fieldName}} should be at most {{max}}'
                    },
                    notEqualTo: {
                        default: '{{_fieldName}} should not be equal To {{value}}'
                    },
                    forbiddenRoles: {
                        default: 'User cannot have customer, and admin role at the same time'
                    },
                    formValid: {
                        default: 'Please fill in all the required fields before attempting to save data'
                    },
                    errorFields: {
                        default: 'There are errors in the following fields - please correct before attempting to save: {{_fieldList}}'
                    },
                    latitudeLongitudenotEqualToZero: {
                        default: 'Latitude and Longitude must not be equal to zero simultaneously'
                    },
                    collectionTimeShouldBeBeforeDeliveryTime: {
                        default: 'Collection End Time should be before Delivery Start Time'
                    },
                    deliveryTimeShouldBeAfterCollectionTime: {
                        default: 'Delivery Start Time should be after Collection End Time'
                    },
                    nullEntity: {
                        default: 'Please fill in this required field'
                    },
                    confirmPassword: {
                        default: 'Confirm password and password not equal'
                    },
                    email: {
                        default: 'Invalid email'
                    },
                    emails: {
                        default: 'Invalid Email'
                    },
                    timeRange: {
                        default: 'Invalid time window'
                    },
                    dateTimePast: {
                        default: 'Date-time is in the past'
                    },
                    maxWeight: {
                        default: 'Invalid weight'
                    },
                    pattern: {
                        default: '{{_fieldName}} is not valid'
                    },
                    pastDate: {
                        default: "Date can't be set on the past"
                    },
                    sameCurrency: {
                        default: 'Currencies cannot be the same'
                    },
                    rate: {
                        default: 'Rate cannot be blank or Zero if Tariff Override is not set'
                    },
                    noMatchError: {
                        default: "Password doesn't match."
                    },
                    driverUnavailable: {
                        default: 'This driver is unavailable during the selected times'
                    },
                    vehicleUnavailable: {
                        default: 'This vehicle is unavailable during the selected times'
                    },
                    trailerUnavailable: {
                        default: 'This trailer contains refused goods'
                    },
                    collectionDateInThePast: {
                        default: "Collection date can't be set in the past"
                    },
                    collectionTimeInThePast: {
                        default: "Collection time can't be set in the past"
                    },
                    deliverBeforeCollection: {
                        default: "Order can't be delivered before collected"
                    },
                    minGreaterThanMax: {
                        default: 'Maximum value must be greater than minimum value'
                    }
                },
                unsavedChangesWarning: {
                    default: 'You have unsaved changes, are you sure you want to continue?'
                }
            },
            fields: {
                name: 'Name',
                accountNo: 'Account Number',
                vatRegNo: 'VAT Registration Number',
                website: 'Website URL',
                registrationNo: 'Registration Number',
                currencyId: 'Currency',
                invoiceTemplateId: 'Invoice Template',
                line1: 'Line 1',
                townCity: 'Town',
                countyState: 'County',
                postCodeZip: 'Post Code'
            },
            selection: {
                selectAll: 'All',
                selectNone: 'None'
            },
            genderWords: {
                m: {
                    _a: '',
                    _the: ''
                },
                f: {
                    _a: '',
                    _the: ''
                }
            }
        }
    }
};
